import(/* webpackMode: "eager" */ "/tmp/build_6d544f5b/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_6d544f5b/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"style\":[\"normal\"],\"subsets\":[\"latin\"]}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager" */ "/tmp/build_6d544f5b/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_6d544f5b/src/components/Atoms/Footer/ConditionalFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_6d544f5b/src/components/Molecules/UserRatingBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoThemeProvider"] */ "/tmp/build_6d544f5b/src/context/DemoThemeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderProvider"] */ "/tmp/build_6d544f5b/src/context/HeaderContext.tsx");
